require("../feedback-content/feedback-content");

const adminRoot = document.querySelector("[data-admin-root]");

function initAdminFeedbackContent() {
  const store = window.NMFeedbackContent;
  if (!store || !adminRoot || window.NMAdminFeedbackContent) return;

  const contentHome = document.querySelector("[data-content-home]");
  const feedbackEditor = document.querySelector('[data-content-editor="feedback"]');
  const feedbackForm = document.querySelector("[data-feedback-admin-form]");
  const feedbackNote = document.querySelector("[data-feedback-note]");

  const FIELDS = [
    "sectionTitle",
    "sectionDescription",
    "phone",
    "popupTitle",
    "popupSubtitle",
    "nameLabel",
    "emailLabel",
    "phoneLabel",
    "buttonText",
    "caption",
    "successMessage",
  ];

  let noteTimer = null;

  function showNote() {
    if (!feedbackNote) return;
    feedbackNote.hidden = false;
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(() => {
      feedbackNote.hidden = true;
    }, 2200);
  }

  function hideOtherEditors() {
    if (contentHome) contentHome.hidden = true;
    document.querySelectorAll("[data-content-editor]").forEach((editor) => {
      const node = editor;
      node.hidden = node.getAttribute("data-content-editor") !== "feedback";
    });
  }

  function clearErrors() {
    feedbackForm?.querySelectorAll("[data-feedback-admin-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-feedback-admin-error]");
      if (error) error.hidden = true;
    });
  }

  function showError(name) {
    const field = feedbackForm?.querySelector(`[data-feedback-admin-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-feedback-admin-error]");
    if (error) error.hidden = false;
  }

  function updateAccentPreview(field) {
    if (!field || !store) return;
    const input = field.querySelector("[data-accent-input]");
    const preview = field.querySelector("[data-accent-preview]");
    if (!input || !preview) return;
    const value = String(input.value || "").trim();
    if (!value) {
      preview.innerHTML = "<span class=\"admin-panel__accent-preview-empty\">Превью заголовка появится здесь</span>";
      return;
    }
    preview.innerHTML = store.formatAccentTitle(value);
  }

  function wrapSelectionWithAccent(input) {
    const start = input.selectionStart;
    const end = input.selectionEnd;
    if (start == null || end == null || start === end) {
      window.alert("Сначала выделите слова в тексте заголовка"); // eslint-disable-line no-alert
      return;
    }

    const value = String(input.value || "");
    const selected = value.slice(start, end);
    const trimmed = selected.trim();
    if (!trimmed) {
      window.alert("Сначала выделите слова в тексте заголовка"); // eslint-disable-line no-alert
      return;
    }

    const leadSpace = selected.match(/^\s*/)?.[0] || "";
    const trailSpace = selected.match(/\s*$/)?.[0] || "";
    const core = selected.slice(leadSpace.length, selected.length - trailSpace.length);
    const alreadyMarked = /^\*[^*]+\*$/.test(core);
    const nextCore = alreadyMarked ? core.replace(/^\*|\*$/g, "") : `*${core.replace(/^\*+|\*+$/g, "")}*`;
    const nextValue = `${value.slice(0, start)}${leadSpace}${nextCore}${trailSpace}${value.slice(end)}`;
    const nextStart = start + leadSpace.length;
    const nextEnd = nextStart + nextCore.length;

    const node = input;
    node.value = nextValue;
    node.focus();
    node.setSelectionRange(nextStart, nextEnd);
    node.dispatchEvent(new Event("input", { bubbles: true }));
  }

  function clearAccentInSelection(input) {
    const value = String(input.value || "");
    let start = input.selectionStart;
    let end = input.selectionEnd;

    if (start == null || end == null || start === end) {
      const nextValue = value.replace(/\*/g, "");
      const node = input;
      node.value = nextValue;
      node.focus();
      node.setSelectionRange(0, nextValue.length);
      node.dispatchEvent(new Event("input", { bubbles: true }));
      return;
    }

    const selected = value.slice(start, end);
    const cleaned = selected.replace(/\*/g, "");
    const nextValue = `${value.slice(0, start)}${cleaned}${value.slice(end)}`;
    const node = input;
    node.value = nextValue;
    node.focus();
    node.setSelectionRange(start, start + cleaned.length);
    node.dispatchEvent(new Event("input", { bubbles: true }));
  }

  function bindAccentFields() {
    feedbackForm?.querySelectorAll("[data-accent-field]").forEach((field) => {
      const input = field.querySelector("[data-accent-input]");
      if (!input || field.dataset.accentBound === "1") return;
      field.dataset.accentBound = "1";

      updateAccentPreview(field);

      input.addEventListener("input", () => updateAccentPreview(field));
      field.querySelector("[data-accent-mark]")?.addEventListener("click", () => {
        wrapSelectionWithAccent(input);
        updateAccentPreview(field);
      });
      field.querySelector("[data-accent-clear]")?.addEventListener("click", () => {
        clearAccentInSelection(input);
        updateAccentPreview(field);
      });
    });
  }

  function fillForm() {
    if (!feedbackForm) return;
    const data = store.getFeedbackData();
    FIELDS.forEach((key) => {
      const input = feedbackForm.elements[key];
      if (input) input.value = data[key] || "";
    });
    if (feedbackNote) feedbackNote.hidden = true;
    clearErrors();
    bindAccentFields();
    feedbackForm.querySelectorAll("[data-accent-field]").forEach(updateAccentPreview);
  }

  function showFeedbackEditor() {
    hideOtherEditors();
    if (feedbackEditor) feedbackEditor.hidden = false;
    fillForm();
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (!feedbackForm) return;
    clearErrors();

    const formData = new FormData(feedbackForm);
    const defaults = store.getDefaultData();
    const payload = { ...defaults };
    let hasError = false;

    FIELDS.forEach((key) => {
      payload[key] = String(formData.get(key) || "").trim();
      if (!payload[key]) {
        showError(key);
        hasError = true;
      }
    });

    if (hasError) return;

    store.saveFeedbackData(payload);
    store.hydrateFeedback();
    showNote();
  }

  document.querySelectorAll('[data-content-open="feedback"]').forEach((button) => {
    button.addEventListener("click", showFeedbackEditor);
  });

  if (feedbackForm) {
    feedbackForm.addEventListener("submit", handleSubmit);
    feedbackForm.querySelectorAll("input, textarea").forEach((input) => {
      input.addEventListener("input", () => {
        const field = input.closest("[data-feedback-admin-field]");
        if (!field) return;
        field.classList.remove("has-error");
        const error = field.querySelector("[data-feedback-admin-error]");
        if (error) error.hidden = true;
      });
    });
    bindAccentFields();
  }

  window.NMAdminFeedbackContent = {
    showFeedbackEditor,
  };
}

if (adminRoot) {
  initAdminFeedbackContent();
  window.setTimeout(initAdminFeedbackContent, 0);
}
